import { __awaiter } from "tslib";
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { ReducerType } from './types';
const initialState = {
    loading: 'idle',
    error: null,
    success: false,
    resetSent: false
};
export var ResetPasswordActionType;
(function (ResetPasswordActionType) {
    ResetPasswordActionType["SendPasswordResetEmail"] = "resetPassword/sendPasswordResetEmail";
    ResetPasswordActionType["ResetPassword"] = "resetPassword/resetPassword";
})(ResetPasswordActionType || (ResetPasswordActionType = {}));
export const sendPasswordResetEmail = createAsyncThunk(ResetPasswordActionType.SendPasswordResetEmail, ({ email, link_url }, { getState, rejectWithValue }) => __awaiter(void 0, void 0, void 0, function* () {
    const { api } = getState().config;
    if (!api)
        return;
    try {
        yield api.postSendPasswordResetEmail(email, link_url);
        return;
    }
    catch (err) {
        return rejectWithValue(err);
    }
}));
export const resetPassword = createAsyncThunk(ResetPasswordActionType.ResetPassword, ({ new_password, resetToken }, { getState, rejectWithValue }) => __awaiter(void 0, void 0, void 0, function* () {
    const { api } = getState().config;
    if (!api)
        return;
    try {
        yield api.postResetPassword(new_password, resetToken);
        return;
    }
    catch (err) {
        return rejectWithValue(err);
    }
}));
const resetPasswordSlice = createSlice({
    name: ReducerType.ResetPassword,
    initialState,
    reducers: {
        resetPasswordReset: () => initialState
    },
    extraReducers: builder => {
        builder
            .addCase(sendPasswordResetEmail.fulfilled, state => {
            state.resetSent = true;
            state.loading = 'idle';
            state.error = null;
        })
            .addCase(sendPasswordResetEmail.pending, state => {
            state.loading = 'pending';
        })
            .addCase(sendPasswordResetEmail.rejected, (state, action) => {
            state.loading = 'idle';
            state.error = action.payload;
        })
            .addCase(resetPassword.fulfilled, state => {
            state.resetSent = false;
            state.success = true;
            state.loading = 'idle';
            state.error = null;
        })
            .addCase(resetPassword.pending, state => {
            state.loading = 'pending';
        })
            .addCase(resetPassword.rejected, (state, action) => {
            state.loading = 'idle';
            state.error = action.payload;
        });
    }
});
export const { resetPasswordReset } = resetPasswordSlice.actions;
export const selectResetPassword = (state) => state.resetPassword;
export const resetPasswordReducer = resetPasswordSlice.reducer;
